<template>
  <v-form
    v-if="!isSubmitted"
    v-model="valid"
    @submit.prevent="submit"
    class="contact-form"
  >
    <h2>{{ $t('ContactForm').title }}</h2>
    <v-row>
      <v-col class="col-12" sm="12" md="6">
        <v-text-field
          color="green"
          v-model="name"
          outlined
          :rules="nameRules"
          :label="this.$t('ContactForm').field1"
          required
        ></v-text-field>

        <v-text-field
          color="green"
          v-model="email"
          outlined
          :rules="emailRules"
          :label="this.$t('ContactForm').field2"
          required
        ></v-text-field>

        <v-text-field
          color="green"
          class="text-field-margin"
          v-model="position"
          outlined
          :label="this.$t('ContactForm').field3"
        ></v-text-field>

        <v-text-field
          color="green"
          v-model="company"
          outlined
          :label="this.$t('ContactForm').field4"
        ></v-text-field>
      </v-col>
      <v-col class="col-12" sm="12" md="6">
        <v-textarea
          color="green"
          v-model="message"
          :rules="messageRules"
          outlined
          :label="this.$t('ContactForm').field5"
          rows="8"
          no-resize
          required
        ></v-textarea>

        <div class="mt-3 d-flex justify-end">
          <v-btn rounded color="red darken-4 white--text" @click="clear">{{
            this.$t('ContactForm').clear
          }}</v-btn>
          <v-btn
            rounded
            class="ml-4"
            color="green white--text"
            :disabled="!valid"
            @click="submit"
            >{{ this.$t('ContactForm').submit }}</v-btn
          >
        </div>
      </v-col>
    </v-row>
  </v-form>
  <!-- if the form was submitted, show confirmation message -->
  <div v-else>
    <div v-if="!submissionFailed">
      <v-alert dense text type="success">{{
        this.$t('ContactForm').submissionMessage1
      }}</v-alert>
    </div>
    <div v-else>
      <v-alert dense outlined type="error">{{
        this.$t('ContactForm').submissionMessage2
      }}</v-alert>
    </div>
  </div>
</template>

<script>
import emailjs from 'emailjs-com'

export default {
  name: 'ContactForm',
  data: () => ({
    isSubmitted: false,
    submissionFailed: false,
    serviceId: 'gmail',
    templateId: 'contact_form_template',
    user_id: 'user_psnePlnUQzmNtJSyNFH94',
    valid: true,
    sentFrom: '',
    position: '',
    company: '',
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 25) || 'Name must be less than 25 characters',
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    message: '',
    messageRules: [v => !!v || 'Message is required'],
  }),

  methods: {
    clear() {
      this.name = ''
      this.email = ''
      this.position = ''
      this.company = ''
      this.message = ''
    },
    submit() {
      //sentFrom - página a partir de onde é enviada a mensagem
      this.sentFrom = this.$route.params.slug

      var template_params = {
        name: this.name,
        user_mail: this.email,
        position: this.position,
        company: this.company,
        message: this.message,
        sentFrom: this.sentFrom,
      }

      if (this.valid) {
        emailjs
          .send(this.serviceId, this.templateId, template_params, this.user_id)
          .then(
            result => {
              this.isSubmitted = true
              this.submissionFailed = false
            },
            error => {
              this.isSubmitted = false
              this.submissionFailed = true
            }
          )
      } else {
        this.isSubmitted = false
        this.submissionFailed = true
      }
    },
  },
}
</script>

<style lang="scss">
.contact-form {
  .v-text-field--outlined.v-input--has-state fieldset {
    border-color: #b71c1c !important;
  }

  .error-text .v-messages__message,
  .v-messages__message {
    color: #b71c1c !important;
  }
}
</style>
